import dynamic from 'next/dynamic';
import React from 'react';
import fa from 'locales/fa.json';
import { pageTitle, seoHref } from 'utils/common.util';

const Navbar = dynamic(() => import('components/Navbar'));
const Conditions = dynamic(() => import('components/Conditions'));
const Footer = dynamic(() => import('components/Footer'));
const Head = dynamic(() => import('next/head'));

const ConditionsPage: React.FC = () => (
  <>
    <Head>
      <title>{pageTitle(fa.conditions.h2)}</title>
      <meta name="description" content={fa.global.seoDescription} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={seoHref().privacy} />
    </Head>

    <Navbar />
    <Conditions />
    <Footer />
  </>
);

export default ConditionsPage;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getServerSideProps = async () => {
  return { props: {} };
};
